import { Col, Container, Row } from "react-bootstrap";
import { useState } from "react";

import DedicatedResources from "../../assets/img/home-it/Dedicated-Resources.png";
import ItConsultancyServices from "../../assets/img/home-it/IT-Consultancy-Services.png";
import ItOutsource from "../../assets/img/home-it/IT-Outsource.png";
import Oracleconsulting from "../../assets/img/home-it/Oracle-consulting.png";
import SoftwareDevelopement from "../../assets/img/home-it/Software-Developement.png";
import BrandAudit from "../../assets/img/landing-page/digital/Brand-Audit.png";
import BrandManagement from "../../assets/img/landing-page/digital/Brand-Management.png";
import SocialMediaMarketing from "../../assets/img/landing-page/digital/Social-Media-Marketing.png";
import SearchEngineOptimization from "../../assets/img/landing-page/digital/SEO.png";
import LinkedInMarketing from "../../assets/img/landing-page/digital/Linked-in.png";
import YouTubeMarketing from "../../assets/img/landing-page/digital/Youtube.png";
import Advertisement from "../../assets/img/landing-page/digital/Digital-Advertising.png";
import InfluencerMarketing from "../../assets/img/landing-page/digital/Influencer.png";
import PhotographyVideography from "../../assets/img/landing-page/digital/Photography.png";
import localSeo from "../../assets/img/landing-page/digital/localSeo.jpg";
import graphic from "../../assets/img/landing-page/digital/graphic.jpg";
import {
  FaAward,
  FaChartLine,
  FaUsers,
  FaBullseye,
  FaLayerGroup,
  FaChartBar,
  FaCoins,
  FaIndustry,
} from "react-icons/fa";

import "./DigitalMarketing.css";
import { Link } from "react-router";

export default function DigitalServices() {
  const [activeFaq, setActiveFaq] = useState(1);

  return (
    <>
      {/* <section className="transform_wrapper global_wrapper">
        <div className="container">
          <div className="transform_wrapper__content">
            <h2>
              Transform Your Business with India’s Leading Digital Marketing
              Experts
            </h2>
            <p className="main-text text-center">
              In today's competitive digital world, having an online presence
              isn't enough, you need a strategy that delivers results. At Global
              Trendz, we provide customized digital marketing services in India
              designed to increase website traffic, generate qualified leads,
              improve conversions, and strengthen your brand. Whether you're a
              startup, local business, enterprise, or eCommerce brand, our
              data-driven marketing strategies help you achieve sustainable
              growth.
            </p>
            <div className="myBtn">
              <Link href="/" className="global_btn">
                Get a Free Strategic Call
              </Link>
            </div>
          </div>
        </div>
      </section> */}

      <section className="information-technology-section digital-marketing-services py-lg-5 pb-4 pt-5 bg-white">
        <Container className="position-relative">
          <Row className="">
            <Col lg={10} className="mx-auto">
              {/* <h2 className="main-title text-center main-title-3 wow animate__animated animate__fadeInUp mb-2">
                A good marketing initiative can get you more customers!{" "}
              </h2> */}
              <h2 className="main-title text-center main-title-3 wow animate__animated animate__fadeInUp mb-2">
                Drive More Leads with the Best Digital Marketing Company in
                India
              </h2>

              <p className="main-text text-center wow animate__animated animate__fadeInUp mb-3 ">
                We provide Innovative, Engaging & Insight Driven Digital
                Marketing Services to grow your business. Our team of dedicated
                <b> Digital Marketing Experts</b> works closely with you to give
                your business the needed boost in generating more sales.
              </p>
            </Col>

            {/* seo */}
            <div className="col-lg-4 col-md-6">
              <Link href="/search-engine-optimization">
                <div className="technology-card text-center">
                  <div className="technology-card-inner">
                    <img
                      src={SearchEngineOptimization}
                      className="img-fluid service-visual"
                      alt="   Search Engine Optimization "
                    />
                    {/* <p className="fst-italic mb-0">Subheading</p> */}
                    <h3 className="how-it-works-card__title">
                      Search Engine Optimization (SEO)
                    </h3>
                    <p className="how-it-works-card__text">
                      Improve your online visibility with result-driven SEO
                      strategies that increase rankings, attract organic
                      traffic, and help your business reach the right audience
                      through search engines and AI Models.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <a href="/search-engine-optimization">
                <div className="technology-card text-center">
                  <div className="technology-card-inner">
                    <img
                      src={localSeo}
                      className="img-fluid service-visual"
                      alt="    GMB (Local SEO)"
                    />
                    {/* <p className="fst-italic mb-0">Subheading</p> */}
                    <h3 className="how-it-works-card__title">
                      Local SEO (GBP){" "}
                    </h3>
                    <p className="how-it-works-card__text">
                      Improve your local online presence with optimized Google
                      Business Profile (GBP) strategies, location-based SEO, and
                      targeted techniques to attract nearby customers and
                      increase visibility.
                    </p>
                  </div>
                </div>
              </a>
            </div>
            {/* social media */}
            <div className="col-lg-4 col-md-6">
              <a href="/social-media-marketing">
                <div className="technology-card text-center">
                  <div className="technology-card-inner">
                    <img
                      src={SocialMediaMarketing}
                      className="img-fluid service-visual"
                      alt="  Social Media Marketing    "
                    />
                    {/* <p className="fst-italic mb-0">Subheading</p> */}
                    <h3 className="how-it-works-card__title">
                      Social Media Marketing (SMM)
                    </h3>
                    <p className="how-it-works-card__text">
                      Build a strong social presence with engaging campaigns,
                      creative content, and strategic management to increase
                      brand awareness, audience engagement, and customer
                      connections across social platforms.
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-lg-4 col-md-6">
              <a href="/search-engine-marketing">
                <div className="technology-card text-center">
                  <div className="technology-card-inner">
                    <img
                      src={BrandAudit}
                      className="img-fluid service-visual"
                      alt="PPC Adverising Services"
                    />
                    {/* <p className="fst-italic mb-0">Subheading</p> */}
                    <h3 className="how-it-works-card__title">
                      PPC Advertisement
                    </h3>
                    <p className="how-it-works-card__text">
                      Generate quality leads and maximize ROI with targeted PPC
                      advertising campaigns designed to reach potential
                      customers, increase conversions, and drive measurable
                      business growth.
                    </p>
                  </div>
                </div>
              </a>
            </div>
            {/* Content Marketing */}
            <div className="col-lg-4 col-md-6">
              <a href="/content-writing">
                <div className="technology-card text-center">
                  <div className="technology-card-inner">
                    <img
                      src={BrandManagement}
                      className="img-fluid service-visual"
                      alt="     Brand Management "
                    />
                    {/* <p className="fst-italic mb-0">Subheading</p> */}
                    <h3 className="how-it-works-card__title">
                      Content Marketing
                    </h3>
                    <p className="how-it-works-card__text">
                      Create valuable, SEO-friendly content that educates your
                      audience, builds brand authority, improves engagement, and
                      drives consistent traffic through strategic content
                      marketing solutions.
                    </p>
                  </div>
                </div>
              </a>
            </div>
            {/* Graphic Design */}
            <div className="col-lg-4 col-md-6">
              <a href="/graphic-designing">
                <div className="technology-card text-center">
                  <div className="technology-card-inner">
                    <img
                      src={graphic}
                      className="img-fluid service-visual"
                      alt="    Graphic Design"
                    />
                    {/* <p className="fst-italic mb-0">Subheading</p> */}
                    <h3 className="how-it-works-card__title">
                      Graphic Designing{" "}
                    </h3>
                    <p className="how-it-works-card__text">
                      Enhance your brand identity with creative graphic designs,
                      including social media creatives, marketing materials, and
                      visual assets that communicate your message effectively.
                    </p>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-4 col-md-6">
              <a href="/">
                <div className="technology-card text-center">
                  <div className="technology-card-inner">
                    <img
                      src={PhotographyVideography}
                      className="img-fluid service-visual"
                      alt="    Photography & Videography"
                    />
                    {/* <p className="fst-italic mb-0">Subheading</p> */}
                    <h3 className="how-it-works-card__title">Photography</h3>
                    <p className="how-it-works-card__text">
                      Photography Capture professional, high-quality visuals
                      that showcase your products, services, and brand story
                      while creating impactful images for marketing campaigns
                      and digital platforms.
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-lg-4 col-md-6">
              <a href="/">
                <div className="technology-card text-center">
                  <div className="technology-card-inner">
                    <img
                      src={InfluencerMarketing}
                      className="img-fluid service-visual"
                      alt="  Influencer Marketing   "
                    />
                    {/* <p className="fst-italic mb-0">Subheading</p> */}
                    <h3 className="how-it-works-card__title">
                      Influencer Marketing
                    </h3>
                    <p className="how-it-works-card__text">
                      Grow your brand reach by collaborating with relevant
                      influencers who connect with your target audience, build
                      trust, and drive awareness through authentic promotions.
                    </p>
                  </div>
                </div>
              </a>
            </div>

            {/* LinkedIn Marketing */}
            <div className="col-lg-4 col-md-6">
              <a href="/">
                <div className="technology-card text-center">
                  <div className="technology-card-inner">
                    <img
                      src={LinkedInMarketing}
                      className="img-fluid service-visual"
                      alt="  LinkedIn Marketing"
                    />
                    {/* <p className="fst-italic mb-0">Subheading</p> */}
                    <h3 className="how-it-works-card__title">
                      LinkedIn Marketing
                    </h3>
                    <p className="how-it-works-card__text">
                      Strengthen your professional network with strategic
                      LinkedIn marketing solutions that enhance brand
                      credibility, generate B2B leads, and engage
                      decision-makers effectively.
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </Row>
        </Container>
      </section>

      {/* why us */}
      <section
        className="why_wrapper global_wrapper"
        style={{ backgroundColor: "whitesmoke" }}>
        <div className="container">
          <Col lg={10} className="mx-auto">
            {/* <h2 className="main-title text-center main-title-3 wow animate__animated animate__fadeInUp mb-2">
                A good marketing initiative can get you more customers!{" "}
              </h2> */}
            <h2 className="main-title text-center main-title-3 wow animate__animated animate__fadeInUp mb-2">
              Why Choose{" "}
              <span style={{ color: "#ff600c" }}> Global Trendz?</span>
            </h2>

            <p className="main-text text-center wow animate__animated animate__fadeInUp mb-3 ">
              Businesses choose <b> Global Trendz</b> because we focus on
              growth, transparency, and measurable performance.
            </p>
          </Col>
          <div className="global_content">
            <div className="row">
              <div className="col-lg-6">
                <div className="why_wrapper__content">
                  <div className="why-grid">
                    <div className="why-card">
                      <div className="why-icon">
                        <FaAward />
                      </div>

                      <div className="why-content">
                        <h3>30+ Years of Industry Experience</h3>

                        <p>
                          With decades of business experience, Global Trendz
                          understands market trends, customer behavior, and
                          industry-specific challenges to create effective
                          marketing strategies.
                        </p>
                      </div>
                    </div>
                    {/* Result-Driven Digital Marketing Strategies */}
                    <div className="why-card">
                      <div className="why-icon">
                        <FaChartLine />
                      </div>

                      <div className="why-content">
                        <h3>Result-Driven Digital Marketing Strategies</h3>

                        <p>
                          We focus on achieving real business outcomes,
                          including increased website traffic, better search
                          rankings, quality leads, higher conversions, and
                          improved ROI.
                        </p>
                      </div>
                    </div>

                    {/* Expert Digital Marketing Team */}
                    <div className="why-card">
                      <div className="why-icon">
                        <FaUsers />
                      </div>

                      <div className="why-content">
                        <h3>Expert Digital Marketing Team</h3>

                        <p>
                          Our team of SEO specialists, PPC experts, social media
                          marketers, content strategists, and web professionals
                          work together to deliver complete digital growth
                          solutions.
                        </p>
                      </div>
                    </div>

                    {/* Customized Marketing Solutions */}
                    <div className="why-card">
                      <div className="why-icon">
                        <FaBullseye />
                      </div>

                      <div className="why-content">
                        <h3>Customized Marketing Solutions</h3>

                        <p>
                          Every business has unique goals. We create
                          personalized digital marketing strategies based on
                          your industry, target audience, competition, and
                          growth objectives.
                        </p>
                      </div>
                    </div>

                    {/* Complete Digital Marketing Services */}
                    <div className="why-card">
                      <div className="why-icon">
                        <FaLayerGroup />
                      </div>

                      <div className="why-content">
                        <h3>
                          Complete Digital Marketing Services Under One Roof
                        </h3>

                        <p>
                          From SEO and Google Ads to social media marketing,
                          website development, content marketing, and ecommerce
                          digital marketing services, we provide end-to-end
                          solutions for your business.
                        </p>
                      </div>
                    </div>

                    {/* Transparent Reporting */}
                    <div className="why-card">
                      <div className="why-icon">
                        <FaChartBar />
                      </div>

                      <div className="why-content">
                        <h3>Transparent Reporting & Performance Tracking</h3>

                        <p>
                          We provide regular updates and detailed reports so you
                          can track campaign performance, understand results,
                          and make informed decisions.
                        </p>
                      </div>
                    </div>

                    {/* ROI & Business Growth */}
                    <div className="why-card">
                      <div className="why-icon">
                        <FaCoins />
                      </div>

                      <div className="why-content">
                        <h3>Focus on ROI and Business Growth</h3>

                        <p>
                          Our goal is not just increasing online visibility but
                          generating meaningful results that help your business
                          grow and maximize your marketing investment.
                        </p>
                      </div>
                    </div>

                    {/* Industry-Specific Expertise */}
                    <div className="why-card">
                      <div className="why-icon">
                        <FaIndustry />
                      </div>

                      <div className="why-content">
                        <h3>Industry-Specific Expertise</h3>

                        <p>
                          We have experience working with businesses across
                          multiple industries, allowing us to create strategies
                          that match your market needs and customer
                          expectations.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="faq_right">
                  <h2>Frequently Asked Questions</h2>

                  <div
                    className={`faqs_box ${activeFaq === 1 ? "active" : ""}`}
                    onClick={() => setActiveFaq(activeFaq === 1 ? null : 1)}>
                    <div className="ques">
                      <h3>
                        1. Why should I choose Global Trendz for digital
                        marketing services in India?
                      </h3>
                    </div>
                    <div className="ans">
                      <p>
                        Global Trendz combines over 30 years of industry
                        experience with data-driven strategies, transparent
                        reporting, and customized marketing solutions that help
                        businesses generate leads, improve rankings, and
                        increase revenue.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`faqs_box ${activeFaq === 2 ? "active" : ""}`}
                    onClick={() => setActiveFaq(activeFaq === 2 ? null : 2)}>
                    <div className="ques">
                      <h3>2. What digital marketing services do you offer?</h3>
                    </div>
                    <div className="ans">
                      <p>
                        We offer SEO, Google Ads, Social Media Marketing,
                        Website Development, Content Marketing, Local SEO,
                        Ecommerce Marketing, and Performance Marketing.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`faqs_box ${activeFaq === 3 ? "active" : ""}`}
                    onClick={() => setActiveFaq(activeFaq === 3 ? null : 3)}>
                    <div className="ques">
                      <h3>
                        3. Do you provide ecommerce digital marketing services?
                      </h3>
                    </div>
                    <div className="ans">
                      <p>
                        Yes. We provide complete Ecommerce digital marketing
                        services, including SEO, Google Shopping Ads, Meta Ads,
                        conversion optimization, remarketing, and marketplace
                        marketing.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`faqs_box ${activeFaq === 4 ? "active" : ""}`}
                    onClick={() => setActiveFaq(activeFaq === 4 ? null : 4)}>
                    <div className="ques">
                      <h3>4. Can you help generate leads for my business?</h3>
                    </div>
                    <div className="ans">
                      <p>
                        Yes. Our digital marketing strategies are focused on
                        generating high-quality leads and increasing conversions
                        through SEO, PPC, and social media marketing.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`faqs_box ${activeFaq === 5 ? "active" : ""}`}
                    onClick={() => setActiveFaq(activeFaq === 5 ? null : 5)}>
                    <div className="ques">
                      <h3>5. Do you work with businesses across India?</h3>
                    </div>
                    <div className="ans">
                      <p>
                        Yes. We provide digital marketing services to businesses
                        across India and also serve international clients.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`faqs_box ${activeFaq === 6 ? "active" : ""}`}
                    onClick={() => setActiveFaq(activeFaq === 6 ? null : 6)}>
                    <div className="ques">
                      <h3>
                        6. Can Global Trendz help improve my marketing ROI?
                      </h3>
                    </div>
                    <div className="ans">
                      <p>
                        Yes. At Global Trendz, we optimize every campaign using
                        data-driven strategies, audience targeting, continuous
                        testing, and performance monitoring to maximize your
                        return on investment.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`faqs_box ${activeFaq === 7 ? "active" : ""}`}
                    onClick={() => setActiveFaq(activeFaq === 7 ? null : 7)}>
                    <div className="ques">
                      <h3>
                        7. Where is Global Trendz located? Can I visit your
                        office for a consultation?
                      </h3>
                    </div>
                    <div className="ans">
                      <p>
                        Global Trendz is a digital marketing company based in
                        Delhi and Chennai. You can visit our office to discuss
                        your business goals, marketing requirements, and growth
                        strategies with our experts. You can also connect with
                        us online for consultations across India.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
